import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"usercase-link"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M8.12132 13.4142C6.94975 14.1953 5.05025 14.1953 3.87868 13.4142C2.70711 12.6332 2.70711 11.3668 3.87868 10.5858C5.05025 9.80474 6.94975 9.80474 8.12132 10.5858C9.29289 11.3668 9.29289 12.6332 8.12132 13.4142Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.1213 13.4142C18.9497 14.1953 17.0503 14.1953 15.8787 13.4142C14.7071 12.6332 14.7071 11.3668 15.8787 10.5858C17.0503 9.80474 18.9497 9.80474 20.1213 10.5858C21.2929 11.3668 21.2929 12.6332 20.1213 13.4142Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M8.12132 13.4142C6.94975 14.1953 5.05025 14.1953 3.87868 13.4142C2.70711 12.6332 2.70711 11.3668 3.87868 10.5858C5.05025 9.80474 6.94975 9.80474 8.12132 10.5858C9.29289 11.3668 9.29289 12.6332 8.12132 13.4142Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M11.998 11.9961H12.002V12H11.998V11.9961Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M20.1213 13.4142C18.9497 14.1953 17.0503 14.1953 15.8787 13.4142C14.7071 12.6332 14.7071 11.3668 15.8787 10.5858C17.0503 9.80474 18.9497 9.80474 20.1213 10.5858C21.2929 11.3668 21.2929 12.6332 20.1213 13.4142Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const UsercaseLink = Vue.extend<IconProps>({
  name: 'UsercaseLinkIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'usercase-link',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default UsercaseLink;
